import { render, staticRenderFns } from "./tutorials.template?vue&type=template&id=de859c2c&lang=pug&"
import script from "./tutorials.client?vue&type=script&lang=ts&"
export * from "./tutorials.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de859c2c')) {
      api.createRecord('de859c2c', component.options)
    } else {
      api.reload('de859c2c', component.options)
    }
    module.hot.accept("./tutorials.template?vue&type=template&id=de859c2c&lang=pug&", function () {
      api.rerender('de859c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/documentation/tutorials/tutorials.component.vue"
export default component.exports